import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import { PostErrorJS } from "@core/auth/jwt/logError";

import i18n from "@/libs/i18n";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import VueGtag from "vue-gtag";

import "vue-multiselect/dist/vue-multiselect.min.css";
// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";
import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";

import "@/libs/vue-lazyload";

import "@/libs/vue-lazyload";

// Axios Mock Adapter
// import '@/@fake-db/db';
import "nprogress/nprogress.css";

import { Utils } from "@core/utils/utilsCustom";

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import Multiselect from "vue-multiselect";

// register globally
Vue.component("multiselect", Multiselect);

import "./filters/filters";


import "@core/utils/validations/validations";
import { Options } from "./utils/options";

Vue.config.productionTip = false;
Vue.prototype.$Utils = Utils;
Vue.prototype.$Options = Options;

Vue.prototype.$loading = {
  show() {
    const el = document.getElementById("loading-bg");
    el.style.display = "block";
    el.style.zIndex = 99999;
    el.style.background = "#ffffff96";
    document.documentElement.style.overflow = "hidden";
  },
  hide() {
    const el = document.getElementById("loading-bg");
    el.style.display = "none";
    el.style.zIndex = 0;
    document.documentElement.style.overflow = "hidden";
  },
};

// Vue.config.errorHandler = function (err, vm, info) {
//   // try {
//   //   PostErrorJS(err.toString(), info, vm.$route.path);
//   //   console.error(err);

//   //   // if (window.location.href.indexOf('localhost') < 0) {
//   //   //   PostErrorJS(err.toString(), info, vm.$route.path);
//   //   // } else {
//   //   //   console.error(err);
//   //   // }
//   // } catch (error) {
//     console.error(error);
//   // }
// };

Vue.prototype.getWr1 = function () {
  var u = localStorage.userData;
  if (u) {
    var u_ = JSON.parse(u);
    if (u_.userType == "0" || u_.userType == "1") {
      return true;
    } else {
      return false;
    }
  }
  return null;
};
Vue.prototype.getWr1Username = function () {
  var u = localStorage.userData;
  if (u) {
    var u_ = JSON.parse(u);
    if (u_.username) {
      return u_.username;
    } else {
      return null;
    }
  }
  return null;
};



Vue.use(VueGtag, {
  config: { id: "G-L0P1NZ6ZYV" },
  appName: 'Wr1',
  pageTrackerScreenviewEnabled: true
}, router);

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

export default app;
